import { useMemo } from 'react';
import type { CanvasObject } from '../types';

/**
 * 클리핑 마스크 맵 생성 훅 (성능 최적화)
 * - Map 기반 조회로 O(1) 성능
 * - 마스크 객체와 클리핑된 객체 그룹핑
 */
export function useClipMask(objects: Map<string, CanvasObject>, zOrder: string[]) {
  const clipMaskMap = useMemo(() => {
    const maskMap = new Map<string, CanvasObject>(); // id -> 마스크 객체
    const isMaskMap = new Set<string>(); // 마스크 객체인 id들
    const clippedGroups = new Map<string, CanvasObject[]>(); // 마스크 id -> 클리핑된 객체들
    
    // 모든 객체를 순회하며 클리핑 관계 파악
    objects.forEach(obj => {
      if (obj.clipMaskId) {
        const maskObj = objects.get(obj.clipMaskId);
        if (maskObj) {
          maskMap.set(obj.clipMaskId, maskObj);
          isMaskMap.add(maskObj.id);
          
          // 클리핑된 객체 그룹핑
          if (!clippedGroups.has(obj.clipMaskId)) {
            clippedGroups.set(obj.clipMaskId, []);
          }
          clippedGroups.get(obj.clipMaskId)!.push(obj);
        }
      }
    });
    
    return {
      maskMap, // 마스크 객체 Map
      isMaskMap, // 마스크 객체인지 확인하는 Set
      clippedGroups // 마스크별 클리핑된 객체 그룹
    };
  }, [objects, zOrder]);
  
  return clipMaskMap;
}

